export enum EnumFinNFe {
    NORMAL = 1,
    COMPLEMENTAR = 2,
    AJUSTE = 3,
    DEVOLUCAO = 4,
}